import React from "react";
import { PhoneOutlined, MailOutlined, HomeOutlined } from "@ant-design/icons";

const CompanyInfo = ({ contactMsg }) => {
  return (
    <div className="flex flex-col justify-start">
      <div className="flex justify-start">
        <img className="w-24" src="http://1.94.62.64:9090/myf/photos/logo_1.jpg" alt="logo1" />
        <img className="w-72" src="http://1.94.62.64:9090/myf/photos/logo_2.jpg" alt="logo2" />
      </div>
      <div>
        {contactMsg && (
          <div className="flex flex-col items-start text-center gap-y-2">
            <span className="flex items-center text-center space-x-1">
              <span className="flex items-center"><PhoneOutlined /></span>
              <span
                className="text-md"
                name="tele">电话：{contactMsg.phone}
              </span>
            </span>
            <span className="flex items-center text-center space-x-1">
              <span className="flex items-center"><MailOutlined /></span>
              <span
                className="text-md"
                name="email">邮箱：{contactMsg.email}
              </span>
            </span>
            <span className="flex items-center text-center space-x-1">
              <span className="flex items-center"><HomeOutlined /></span>
              <span
                className="text-md"
                name="locate">地址：{contactMsg.companyPath}
              </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyInfo;
